import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select'
import TextAreaJSX from './TextAreaJSX';
import InputTextJSX from './InputTextJSX';
import InputDateJSX from './InputDateJSX';
import SelectReactJSX from './SelectReactJSX';
import { useDispatch, useSelector } from 'react-redux';
import { getFFSeaImpConsigneeBranch, getFFSeaImpConsigneeBranchBank, getFFSeaImpOrganisationBranch, getFFSeaImpShipperBranch, getFFSeaImpShipperBranchBank, getFFSICity, getFFSICountry, getFFSISeaport, getFFSIState, getPackageInfoByQuotation } from '../../../../../../../Redux/action/FreightForwarding/Sea/FFSeaImpAction';
import { error } from 'jquery';
import { customStyles } from '../../../../../../../HelperFunctions';
import { adminMainUrl } from '../../../../../../../Config';

const ConsoleShipmentSIHBLAdd = ({
    trans_mode,
    job_order_id,
    quotation_id,
    loadingCurrency,
    currencyOptions,
    loadingAirport,
    airportOptions,
    loadingOrganisation,
    organisationOptions,
    token,
    user_id,
    joborderffdetails
}) => {
    const [disableSubmit, setDisableSubmit] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();


    useEffect(() => {
        if (token && user_id) {
            dispatch(getFFSICountry(token, user_id));
            dispatch(getFFSISeaport(token, user_id));
        }
    }, []);



    let [shipperOrganisationOptions, setShipperOrganisationOptions] = useState([]);
    let [consigneeOrganisationOptions, setConsigneeOrganisationOptions] = useState([]);

    let [shipperBranchOptions, setShipperBranchOptions] = useState([]);
    let [consigneeBranchOptions, setConsigneeBranchOptions] = useState([]);

    let [shipperBankOptions, setShipperBankOptions] = useState([]);
    let [consigneeBankOptions, setConsigneeBankOptions] = useState([]);

    let [countryOptions, setCountryOptions] = useState([]);
    let [stateOptions, setStateOptions] = useState([]);
    let [cityOptions, setCityOptions] = useState([]);
    let [seaportOptions, setSeaportOptions] = useState([]);


    useEffect(() => {
        if (organisationOptions) {
            let shipperArr = [];
            let consigneeArr = [];

            organisationOptions.map(object => {
                if (object.entity && object.entity.includes("shipper")) {
                    shipperArr.push(object);
                }
                if (object.entity && object.entity.includes("consignee")) {
                    consigneeArr.push(object);
                }
            });
            setShipperOrganisationOptions(shipperArr);
            setConsigneeOrganisationOptions(consigneeArr);
        }
    }, [organisationOptions]);


    useEffect(() => {
        if (token && user_id && quotation_id) {
            dispatch(getPackageInfoByQuotation(token, user_id, quotation_id))
        }
    }, [quotation_id]);


    const handleShipperBranch = (shipper_id) => {
        if (shipper_id && token && user_id) {
            dispatch(getFFSeaImpShipperBranch(token, user_id, shipper_id));
        }
    };
    const handleShipperBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFSeaImpShipperBranchBank(token, user_id, branch_id));
        }
    };

    const handleConsigneeBranch = (consignee_id) => {
        if (consignee_id && token && user_id) {
            dispatch(getFFSeaImpConsigneeBranch(token, user_id, consignee_id));
        }
    };
    const handleConsigneeBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFSeaImpConsigneeBranchBank(token, user_id, branch_id));
        }
    };


    const {
        //organisation shipper branch list
        loadingFFSeaImpShipperBranchList,
        FFSeaImpShipperBranchList,
        FFSeaImpShipperBranchListError,

        //organisation consignee branch list
        loadingFFSeaImpConsigneeBranchList,
        FFSeaImpConsigneeBranchList,
        FFSeaImpConsigneeBranchListError,

        //organisatoin shipper branch bank list
        loadingFFSeaImpShipperBranchBankList,
        FFSeaImpShipperBranchBankList,
        FFSeaImpShipperBranchBankListError,

        //organisatoin consignee branch bank list
        loadingFFSeaImpConsigneeBranchBankList,
        FFSeaImpConsigneeBranchBankList,
        FFSeaImpConsigneeBranchBankListError,

        //query INFO
        loadingFFQueryDetail,
        FFQueryDetail,
        FFQueryDetailError,

        //country city state seaport
        loadingFFSICountry,
        FFSICountry,
        FFSICountryError,
        loadingFFSIState,
        FFSIState,
        FFSIStateError,
        loadingFFSICity,
        FFSICity,
        FFSICityError,
        loadingFFSISeaport,
        FFSISeaport,
        FFSISeaportError,

    } = useSelector(state => state.FFSeaImpReducer);


    useEffect(() => {
        if (FFSICountry) {
            let arr = [];
            FFSICountry.map(val => arr.push({ value: val.id, label: val.name }));
            setCountryOptions(arr);
        }
    }, [loadingFFSICountry, FFSICountry])

    useEffect(() => {
        if (FFSIState) {
            let arr = [];
            FFSIState.map(val => arr.push({ value: val.id, label: val.name }));
            setStateOptions(arr);
        }
    }, [loadingFFSIState, FFSIState]);

    useEffect(() => {
        if (FFSICity) {
            let arr = [];
            FFSICity.map(val => arr.push({ value: val.id, label: val.name }));
            setCityOptions(arr);
        }
    }, [loadingFFSICity, FFSICity])
    useEffect(() => {
        if (FFSISeaport) {
            let arr = [];
            FFSISeaport.map(val => arr.push({ value: val.id, label: val.name }));
            setSeaportOptions(arr);
        }
    }, [loadingFFSISeaport, FFSISeaport])

    useEffect(() => {
        // console.log(FFSeaImpShipperBranchList);
        if (FFSeaImpShipperBranchList) {
            let arr = [];
            FFSeaImpShipperBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setShipperBranchOptions(arr);
        }
    }, [FFSeaImpShipperBranchList]);


    useEffect(() => {
        if (FFSeaImpShipperBranchBankList) {
            let arr = [];
            FFSeaImpShipperBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setShipperBankOptions(arr);
        }
    }, [FFSeaImpShipperBranchBankList]);

    useEffect(() => {
        if (FFSeaImpConsigneeBranchList) {
            let arr = [];
            FFSeaImpConsigneeBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setConsigneeBranchOptions(arr);
        }
    }, [FFSeaImpConsigneeBranchList]);

    useEffect(() => {
        if (FFSeaImpConsigneeBranchBankList) {
            let arr = [];
            FFSeaImpConsigneeBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setConsigneeBankOptions(arr);
        }
    }, [FFSeaImpConsigneeBranchBankList]);


    const initialValues = {
        job_order_id: 0,
        quotation_id: 0,
        shipper_id: 0,
        shipper_branch_id: 0,
        shipper_branch_address_id: 0,
        consignee_id: 0,
        consignee_branch_id: 0,
        consignee_branch_address_id: 0,
        notify_address: "",
        notify_email_address: "",
        place_of_acceptance: "",
        port_of_loading: "",
        port_of_discharge: "",
        place_of_delivery: "",
        vessel_and_voyage_no: "",
        product_description_json: "",
        freight_term: "",
        freight_payable_at: "",
        number_of_original_mdt: "",
        place_of_issue: "",
        place_of_date: "",
        other_particular_address: "",
        other_particular_country: "",
        other_particular_city: "",
        other_particular_state: "",
        other_particular_zipcode: "",
        shipped_on_board_date: "",
        delivery_of_goods_apply_to_address: "",
        delivery_of_goods_apply_to_email: "",
        delivery_of_goods_apply_to_tax_id: "",
        delivery_of_goods_apply_to_zc: "",
        is_sli_recived: "",
        rows: [
            {
                no_of_package: "0",
                goods_description: "",
                gross_weight: "",
                gross_weight_unit: "",
                measurement: "",
                invoice_no: "",
                sb_no: "",
                sb_date: "",
                net_weight: "",
                net_weight_unit: "",
                container_number: ""
            }
        ]
    }

    const formik = useFormik({
        initialValues: initialValues,
        validate: (values) => {
            const errors = {};
            if (values.notify_email_address && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.notify_email_address)) {
                errors.notify_email_address = 'Invalid email address';
            }
            if (values.delivery_of_goods_apply_to_email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.delivery_of_goods_apply_to_email)) {
                errors.delivery_of_goods_apply_to_email = 'Invalid email address';
            }

            if (values.number_of_original_mdt !== undefined && values.number_of_original_mdt !== '') {
                const num = parseInt(values.number_of_original_mdt, 10);
                if (num < 1 || num > 10) {
                    errors.number_of_original_mdt = 'Must be between 1 and 10';
                }
            }

            if (values.rows && values.rows.length > 0) {
                const rowsErrors = [];
                let hasRowErrors = false;
                values.rows.forEach((row, index) => {
                    const rowErrors = {};
                    if (row.container_number) {
                        if (!/^[A-Z]{4}\d{7}$/.test(row.container_number)) {
                            rowErrors.container_number = 'Invalid Container Number Format. Container Number must contain 4 alphabets followed by 7 numeric digits';
                            hasRowErrors = true;
                        }
                    }
                    rowsErrors[index] = rowErrors;
                });
                if (hasRowErrors) {
                    errors.rows = rowsErrors;
                }
            }

            return errors;
        },
        onSubmit: (values, { resetForm }) => {
            // console.log(values);
            values.job_order_id = job_order_id;
            values.quotation_id = quotation_id;

            values.product_description_json = values.rows
            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                axios.post(`${adminMainUrl}/api/freight/forwarding/sea/import/hbl/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            resetForm();
                            //reset all the dropdowns
                            setShipperOrganisationOptions([]);
                            setConsigneeOrganisationOptions([]);
                            setShipperBranchOptions([]);
                            setConsigneeBranchOptions([]);
                            setCountryOptions([]);
                            setStateOptions([]);
                            setCityOptions([]);
                            setSeaportOptions([]);
                            navigate(`/flexichain/job-order/freight-forwarding/shipment/sea/import/console/hbl`)

                            // navigate(`/flexichain/job-order/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    useEffect(() => {
        if (formik.values.other_particular_country) {
            dispatch(getFFSIState(token, user_id, formik.values.other_particular_country));
        }
    }, [formik.values.other_particular_country])
    useEffect(() => {
        if (formik.values.other_particular_state) {
            dispatch(getFFSICity(token, user_id, formik.values.other_particular_state));
        }
    }, [formik.values.other_particular_state])

    useEffect(() => {
        if (FFQueryDetail) {
            // console.log(FFQueryDetail);

            if (FFQueryDetail.pl_package_info) {
                let parsedJSON = JSON.parse(FFQueryDetail.pl_package_info);
                if (FFQueryDetail.shipment_mode == "ocean" && FFQueryDetail.load_type == "FULL") {
                    let arr = [
                        {
                            no_of_package: `${FFQueryDetail.fl_quantity} ${FFQueryDetail.container_size}` ?? 0,
                            goods_description: "",
                            gross_weight: "0",
                            gross_weight_unit: "",
                            measurement: FFQueryDetail.container_size,
                            invoice_no: "",
                            sb_no: "",
                            sb_date: "",
                            net_weight: FFQueryDetail.fl_weight,
                            net_weight_unit: FFQueryDetail.fl_weight_unit_id,
                            container_number: "",
                        }
                    ];
                    formik.setFieldValue("rows", arr);

                } else if (Array.isArray(parsedJSON)) {
                    const updatedRows = parsedJSON.map((item) => {

                        // console.log("ITEM", item);
                        // Extract values from API response
                        const { total_boxes, gross_weight, gross_weight_unit, max_weight, max_weight_unit, length, width, height, dimensionunit, volume, volumeunit } = item;

                        // Determine the correct kg_lb value (case insensitive match)
                        const validUnits = ["kgs", "lbs", "ton"];
                        const kg_lb = validUnits.includes(gross_weight_unit.toLowerCase())
                            ? gross_weight_unit
                            : ""; // Set to empty if invalid


                        //set dimensions, if LWH exists, show L X B X H unit otherwise show volume unit

                        let dimension = "";
                        if (FFQueryDetail.package_volume_type == "DIMENSIONS") {
                            dimension = `${length ?? 0} X ${width ?? 0} X ${height ?? 0} ${dimensionunit}`
                        } else if (FFQueryDetail.package_volume_type == "VOLUME") {
                            dimension = `${volume ?? 0} ${volumeunit}`
                        }



                        // Map fields to form row structure
                        return {
                            no_of_package: total_boxes || "",
                            goods_description: "",
                            gross_weight: gross_weight || "",
                            gross_weight_unit: gross_weight_unit || "",
                            measurement: dimension,
                            invoice_no: "",
                            sb_no: "",
                            sb_date: "",
                            net_weight: max_weight || "",
                            net_weight_unit: max_weight_unit || "",
                            container_number: "",
                        };
                    });

                    // Update formik values
                    formik.setFieldValue("rows", updatedRows);
                } else {
                    formik.setFieldValue("rows", [{
                        no_of_package: "0",
                        goods_description: "",
                        gross_weight: "",
                        gross_weight_unit: "",
                        measurement: "",
                        invoice_no: "",
                        sb_no: "",
                        sb_date: "",
                        net_weight: "",
                        net_weight_unit: "",
                        container_number: ""
                    }]);
                }
            } else {
                formik.setFieldValue("rows", [{
                    no_of_package: "0",
                    goods_description: "",
                    gross_weight: "",
                    gross_weight_unit: "",
                    measurement: "",
                    invoice_no: "",
                    sb_no: "",
                    sb_date: "",
                    net_weight: "",
                    net_weight_unit: "",
                    container_number: ""
                }]);
            }
        }

    }, [FFQueryDetail])



    useEffect(() => {
        let num1 = !isNaN(Number(formik.values.weight_charge_prepaid)) ? Number(formik.values.weight_charge_prepaid) : 0;
        let num2 = !isNaN(Number(formik.values.valuation_charge_prepaid)) ? Number(formik.values.valuation_chapkgrge_prepaid) : 0;
        let num3 = !isNaN(Number(formik.values.tax_prepaid)) ? Number(formik.values.tax_prepaid) : 0;
        let num4 = !isNaN(Number(formik.values.total_due_agent_prepaid)) ? Number(formik.values.total_due_agent_prepaid) : 0;
        let num5 = !isNaN(Number(formik.values.total_due_carrier_prepaid)) ? Number(formik.values.total_due_carrier_prepaid) : 0;
        formik.setFieldValue("total_prepaid", num1 + num2 + num3 + num4 + num5);
    }, [
        formik.values.weight_charge_prepaid,
        formik.values.valuation_charge_prepaid,
        formik.values.tax_prepaid,
        formik.values.total_due_agent_prepaid,
        formik.values.total_due_carrier_prepaid,
    ]);

    useEffect(() => {
        let num1 = !isNaN(Number(formik.values.weight_charge_collect)) ? Number(formik.values.weight_charge_collect) : 0;
        let num2 = !isNaN(Number(formik.values.valuation_charge_collect)) ? Number(formik.values.valuation_charge_collect) : 0;
        let num3 = !isNaN(Number(formik.values.tax_collect)) ? Number(formik.values.tax_collect) : 0;
        let num4 = !isNaN(Number(formik.values.total_due_agent_collect)) ? Number(formik.values.total_due_agent_collect) : 0;
        let num5 = !isNaN(Number(formik.values.total_due_carrier_collect)) ? Number(formik.values.total_due_carrier_collect) : 0;
        formik.setFieldValue("total_collect", num1 + num2 + num3 + num4 + num5);
    }, [
        formik.values.weight_charge_collect,
        formik.values.valuation_charge_collect,
        formik.values.tax_collect,
        formik.values.total_due_agent_collect,
        formik.values.total_due_carrier_collect,
    ]);

    const [disableDownloadPDF, setDisableDownloadPDF] = useState(false);
    const [disableDownloadDOC, setDisableDownloadDOC] = useState(false);


    const downloadSLIPDF = () => {
        setDisableDownloadPDF(true);
        let config = { headers: { 'auth-token': token, user_id: user_id }, responseType: 'blob', };
        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/sea/export/hbl/sli-pdf-download`, config)
                .then(response => {
                    if (response.status == 200) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'FlexichainSLI.pdf');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadPDF(false);
                    } else {
                        toast.error(response.error.message);
                        setDisableDownloadPDF(false);
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error(error.message);
                    setDisableDownloadPDF(false);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
            setDisableDownloadPDF(false);
        }
    }

    const downloadSLIDOC = () => {
        setDisableDownloadDOC(true);
        let config = {
            headers: { 'auth-token': token, user_id: user_id },
            responseType: 'blob' // Ensure the response is treated as a binary blob
        };

        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/air/export/hawb/sli-doc-download`, config)
                .then(response => {
                    if (response.status === 200) {
                        // Create a Blob object from the response data
                        const blob = new Blob([response.data], { type: 'application/msword' });
                        const url = window.URL.createObjectURL(blob);

                        // Create an anchor element and trigger the download
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'FlexichainSLI.doc'); // Set the filename
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link); // Clean up the DOM
                        setDisableDownloadDOC(false);
                    } else {
                        toast.error(response.error.message || "Error downloading the document");
                        setDisableDownloadDOC(false);
                    }
                })
                .catch(error => {
                    console.error(error);
                    toast.error(error.message || "Error during download");
                    setDisableDownloadDOC(false);
                });
        } catch (error) {
            console.error(error);
            toast.error(error.message || "Unexpected error occurred");
            setDisableDownloadDOC(false);
        }
    };


    useEffect(() => {
        if (joborderffdetails) {
            formik.setFieldValue("shipper_id", joborderffdetails.shipper_id ? joborderffdetails.shipper_id : 0);
            if (joborderffdetails.shipper_id) {
                handleShipperBranch(joborderffdetails.shipper_id);
            }
            formik.setFieldValue("shipper_branch_id", joborderffdetails.shipper_branch_id ? joborderffdetails.shipper_branch_id : 0);
            formik.setFieldValue("shipper_branch_bank_account_id", joborderffdetails.shipper_branch_bank_account_id ? joborderffdetails.shipper_branch_bank_account_id : 0);
            formik.setFieldValue("consignee_id", joborderffdetails.consignee_id ? joborderffdetails.consignee_id : 0);
            if (joborderffdetails.consignee_id) {
                handleConsigneeBranch(joborderffdetails.consignee_id);
            }
            formik.setFieldValue("consignee_branch_id", joborderffdetails.consignee_branch_id ? joborderffdetails.consignee_branch_id : 0);
            formik.setFieldValue("consignee_branch_bank_account_id", joborderffdetails.consignee_branch_bank_account_id ? joborderffdetails.consignee_branch_bank_account_id : 0);
            formik.setFieldValue("port_of_loading", joborderffdetails.port_of_loading ? joborderffdetails.port_of_loading : 0);
            formik.setFieldValue("port_of_discharge", joborderffdetails.port_of_discharge ? joborderffdetails.port_of_discharge : 0);
            formik.setFieldValue("place_of_acceptance", joborderffdetails.place_of_acceptance ? joborderffdetails.place_of_acceptance : "");
            formik.setFieldValue("place_of_delivery", joborderffdetails.place_of_delivery ? joborderffdetails.place_of_delivery : "");
            formik.setFieldValue("vessel_and_voyage_no", joborderffdetails.vessel_and_voyage_no ? joborderffdetails.vessel_and_voyage_no : "");
            formik.setFieldValue("freight_term", joborderffdetails.freight_term ? joborderffdetails.freight_term : "");
            formik.setFieldValue("freight_payable_at", joborderffdetails.freight_payable_at ? joborderffdetails.freight_payable_at : "");
            formik.setFieldValue("number_of_original_mdt", joborderffdetails.number_of_original_mdt ? joborderffdetails.number_of_original_mdt : "");
            formik.setFieldValue("place_of_issue", joborderffdetails.place_of_issue ? joborderffdetails.place_of_issue : "");
            formik.setFieldValue("place_of_date", joborderffdetails.place_of_date ? joborderffdetails.place_of_date : "");
            formik.setFieldValue("notify_address", joborderffdetails.notify_address ? joborderffdetails.notify_address : "");
            formik.setFieldValue("notify_email_address", joborderffdetails.notify_email_address ? joborderffdetails.notify_email_address : "");
            formik.setFieldValue("delivery_of_goods_apply_to_address", joborderffdetails.delivery_of_goods_apply_to_address ? joborderffdetails.delivery_of_goods_apply_to_address : "");
            formik.setFieldValue("delivery_of_goods_apply_to_email", joborderffdetails.delivery_of_goods_apply_to_email ? joborderffdetails.delivery_of_goods_apply_to_email : "");
            formik.setFieldValue("delivery_of_goods_apply_to_tax_id", joborderffdetails.delivery_of_goods_apply_to_tax_id ? joborderffdetails.delivery_of_goods_apply_to_tax_id : "");
            formik.setFieldValue("delivery_of_goods_apply_to_zc", joborderffdetails.delivery_of_goods_apply_to_zc ? joborderffdetails.delivery_of_goods_apply_to_zc : "");
        }
    }, [joborderffdetails])



    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="row">
                    <h3 className='mt-2'>HBL</h3>
                    <div className="col-md-12">
                        <div className="row subheading-strip">
                            <div className="col-md-12">
                                <h4 className='mt-2'>Party Details</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                SLI received
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select
                                    className='form-control form-control-sm'
                                    name="is_sli_recived"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.is_sli_recived}
                                >
                                    <option value="" disabled>-</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {
                        formik.values.is_sli_recived === 'Yes' && (
                            <div className="col-md-3 mt-2 d-flex align-items-center justify-content-end">
                                <div className="row d-flex justify-content-end">
                                    <div className="col-md-6"><button className="btn btn-sm btn-primary" type="button" onClick={downloadSLIPDF} disabled={disableDownloadPDF}>{disableDownloadPDF ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (PDF)</>}</button></div>
                                    {/* <div className="col-md-6"><button className="btn btn-sm btn-primary" type="button" onClick={downloadSLIDOC} disabled={disableDownloadDOC} style={{ whiteSpace: "nowrap" }}>{disableDownloadDOC ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (DOC)</>}</button></div> */}
                                    <div className="col-md-6"><Link className="btn btn-sm btn-primary" type="button" style={{ whiteSpace: "nowrap" }} to={`${adminMainUrl}/FreightForwardingSLI/FF_AI_SLI.docx`}>{disableDownloadDOC ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (DOC)</>}</Link></div>
                                </div>
                            </div>
                        )
                    }
                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Shipper
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={shipperOrganisationOptions}
                                    styles={customStyles}
                                    name="shipper_id"
                                    onChange={option => {
                                        formik.setFieldValue("shipper_branch_id", "");
                                        setShipperBranchOptions([]);
                                        formik.setFieldValue('shipper_id', option.value);
                                        handleShipperBranch(option.value);
                                    }}
                                    value={shipperOrganisationOptions.find(option => option.value === formik.values.shipper_id || null)}
                                    isLoading={loadingOrganisation}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Shipper Branch
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={shipperBranchOptions}
                                    styles={customStyles}
                                    name="shipper_branch_id"
                                    onChange={option => {
                                        formik.setFieldValue('shipper_branch_id', option.value);
                                        handleShipperBanks(option.value);
                                    }}
                                    value={shipperBranchOptions.find(option => option.value === formik.values.shipper_branch_id || null)}
                                    isLoading={loadingFFSeaImpShipperBranchList}
                                // isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Consignee
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={consigneeOrganisationOptions}
                                    styles={customStyles}
                                    name="quotation_id"
                                    onChange={option => {
                                        setConsigneeBranchOptions([]);
                                        formik.setFieldValue("consignee_branch_id", "");
                                        formik.setFieldValue('consignee_id', option.value);
                                        handleConsigneeBranch(option.value);
                                    }}
                                    value={consigneeOrganisationOptions.find(option => option.value === formik.values.consignee_id || null)}
                                    isLoading={loadingOrganisation}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Consignee Branch
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={consigneeBranchOptions}
                                    styles={customStyles}
                                    name="consignee_branch_id"
                                    onChange={option => {
                                        formik.setFieldValue('consignee_branch_id', option.value);
                                        handleConsigneeBanks(option.value);
                                    }}
                                    value={consigneeBranchOptions.find(option => option.value === formik.values.consignee_branch_id || null)}
                                    isLoading={loadingFFSeaImpShipperBranchList}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>


                    {/* Notify  */}
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Notify Address
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <textarea
                                    className='form-control'
                                    id="notify_address"
                                    name="notify_address"
                                    value={formik.values.notify_address}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mt-2">
                        <InputTextJSX labelText={"Notify Email"} nameValue={"notify_email_address"} value={formik.values.notify_email_address} onChange={formik.handleChange} maxLength={100} />
                    </div>
                    <div className="col-md-3 mt-2">
                        <InputTextJSX labelText={"Place of acceptance"} nameValue={"place_of_acceptance"} value={formik.values.place_of_acceptance} onChange={formik.handleChange} maxLength={250} />
                    </div>



                    {/* Ports of loading and discharge */}
                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Port of Loading
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={seaportOptions}
                                    styles={customStyles}
                                    name="port_of_loading"
                                    onChange={option => {
                                        formik.setFieldValue('port_of_loading', option.value);
                                    }}
                                    value={seaportOptions.find(option => option.value == formik.values.port_of_loading || null)}
                                    isLoading={loadingFFSeaImpConsigneeBranchBankList}
                                // isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Port of Discharge
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={seaportOptions}
                                    styles={customStyles}
                                    name="port_of_discharge"
                                    onChange={option => {
                                        formik.setFieldValue('port_of_discharge', option.value);
                                    }}
                                    value={seaportOptions.find(option => option.value == formik.values.port_of_discharge || null)}
                                    isLoading={loadingFFSeaImpConsigneeBranchBankList}
                                // isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mt-2">
                        <InputTextJSX labelText={"Place of delivery"} nameValue={"place_of_delivery"} value={formik.values.place_of_delivery} onChange={formik.handleChange} maxLength={250} />
                    </div>
                    <div className="col-md-3 mt-2">
                        <InputTextJSX labelText={"Vessel & Voyage No."} nameValue={"vessel_and_voyage_no"} value={formik.values.vessel_and_voyage_no} onChange={formik.handleChange} maxLength={250} />
                    </div>
                    <div className="col-md-3 mt-2">
                        <SelectReactJSX
                            labelText={"Freight Term"}
                            nameValue={"freight_term"}
                            options={[
                                { value: 'Prepaid', label: 'Prepaid' },
                                { value: 'Collect', label: 'Collect' }
                            ]}
                            onChange={(option) => formik.setFieldValue("freight_term", option ? option.value : "")}
                            value={[
                                { value: 'Prepaid', label: 'Prepaid' },
                                { value: 'Collect', label: 'Collect' }
                            ].find(opt => opt.value === formik.values.freight_term) || null}
                        />
                    </div>
                    <div className="col-md-3 mt-2">
                        <InputTextJSX labelText={"Freight Payable At"} nameValue={"freight_payable_at"} value={formik.values.freight_payable_at} onChange={formik.handleChange} maxLength={250} />

                    </div>




                    <div className={`col-md-3 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                No. of Original MTDs
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="text"
                                    maxLength={2}
                                    className="form-control form-control-sm"
                                    id="number_of_original_mdt"
                                    name="number_of_original_mdt"
                                    value={formik.values.number_of_original_mdt}
                                    onBlur={formik.handleBlur}
                                    onChange={(e) => {
                                        let value = e.target.value.replace(/[^0-9]/g, '');

                                        // Allow empty value while typing
                                        if (value === '') {
                                            formik.setFieldValue('number_of_original_mdt', '');
                                            return;
                                        }

                                        // Accept only 1 to 10
                                        const number = Number(value);

                                        if (number >= 1 && number <= 10) {
                                            formik.setFieldValue('number_of_original_mdt', value);
                                        } else {
                                            e.target.value = formik.values.number_of_original_mdt || '';
                                        }
                                    }}

                                />
                                {formik.errors.number_of_original_mdt && formik.touched.number_of_original_mdt && (
                                    <div className="text-danger" style={{ fontSize: '11px', marginTop: '2px' }}>
                                        {formik.errors.number_of_original_mdt}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                     <div className={`col-md-3 mt-2`}>
                        <InputTextJSX labelText={"Place of issue"} nameValue={"place_of_issue"} value={formik.values.place_of_issue} onChange={formik.handleChange} maxLength={250} />
                     </div>
                    
                    <div className={`col-md-3 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Date of Issue
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    id="place_of_date"
                                    name="place_of_date"
                                    value={formik.values.place_of_date}
                                    onChange={formik.handleChange}
                                />
                            </div>
                        </div>
                    </div>


                    <h4 className='mt-2 subheading-strip'>For delivery of goods please apply to:</h4>
                     <div className={`col-md-3 mt-2`}>
                        <InputTextJSX labelText={"Address"} nameValue={"delivery_of_goods_apply_to_address"} value={formik.values.delivery_of_goods_apply_to_address} onChange={formik.handleChange} maxLength={250} />
                     </div>
                     <div className={`col-md-3 mt-2`}>
                        <InputTextJSX labelText={"Email"} nameValue={"delivery_of_goods_apply_to_email"} value={formik.values.delivery_of_goods_apply_to_email} onChange={formik.handleChange} maxlength={60} />
                     </div>
                     <div className={`col-md-3 mt-2`}>
                        <InputTextJSX labelText={"Tax ID"} nameValue={"delivery_of_goods_apply_to_tax_id"} value={formik.values.delivery_of_goods_apply_to_tax_id} onChange={formik.handleChange} maxlength={20} />
                     </div>
                     <div className={`col-md-3 mt-2`}>
                        <InputTextJSX labelText={"ZC"} nameValue={"delivery_of_goods_apply_to_zc"} value={formik.values.delivery_of_goods_apply_to_zc} onChange={formik.handleChange} maxlength={10} />
                     </div>
                    
                    
                    
                    

                    <h4 className='mt-2 subheading-strip'>Rate Description</h4>
                    <div className="table-responsive">
                        <table className="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">Container No.(s)*</th>
                                    <th scope="col">Marks & Number*</th>
                                    <th scope="col">Invoice Number</th>
                                    <th scope="col">SB Number.*</th>
                                    <th scope="col">SB Date*</th>
                                    <th scope="col">Total Gross Weight*</th>
                                    <th scope="col">Gross Weight Unit*</th>
                                    <th scope="col">Total Net Weight*</th>
                                    <th scope="col">Net Weight Unit*</th>
                                    <th scope="col">Measurement of Goods</th>
                                    <th scope="col">Goods Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {formik.values.rows.map((row, index) => (
                                    <tr key={index}>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].container_number`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                maxLength={11}
                                                value={row.container_number}
                                                pattern="[A-Z]{4}[0-9]{7}"
                                                title="Container number must be 4 uppercase letters followed by 7 digits (e.g., ABCD1234567)"
                                                onInput={(event) => {
                                                    let value = event.target.value.toUpperCase();
                                                    value = value.replace(/[^A-Z0-9]/g, '');
                                                    if (value.length > 11) value = value.slice(0, 11);
                                                    event.target.value = value;
                                                    formik.handleChange(event);
                                                }}
                                            />
                                            {formik.errors.rows?.[index]?.container_number && formik.touched.rows?.[index]?.container_number && (
                                                <div className="text-danger" style={{ fontSize: '11px', marginTop: '2px' }}>
                                                    {formik.errors.rows[index].container_number}
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                maxlength={50}
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].no_of_package`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.no_of_package}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                maxlength={50}
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].invoice_no`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.invoice_no}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                maxlength={50}
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].sb_no`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.sb_no}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="date"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].sb_date`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.sb_date}
                                                min="1900-01-01"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].gross_weight`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.gross_weight}
                                                maxLength={10}
                                                onInput={(event) => {
                                                    let value = event.target.value;

                                                    value = value.replace(/[^0-9.]/g, '');

                                                    const parts = value.split('.');

                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }

                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }

                                                    event.target.value = value;
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].gross_weight_unit`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.gross_weight_unit}
                                            >
                                                <option value="" disabled>-</option>
                                                <option value="Kgs">Kgs</option>
                                                <option value="Lbs">Lbs</option>
                                                <option value="Ton">Ton</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].net_weight`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.net_weight}
                                                maxLength={10}
                                                onInput={(event) => {
                                                    let value = event.target.value;

                                                    value = value.replace(/[^0-9.]/g, '');

                                                    const parts = value.split('.');

                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }

                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }

                                                    event.target.value = value;
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].net_weight_unit`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.net_weight_unit}
                                            >
                                                <option value="" disabled>-</option>
                                                <option value="Kgs">Kgs</option>
                                                <option value="Lbs">Lbs</option>
                                                <option value="Ton">Ton</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].measurement`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.measurement}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                className='form-control'
                                                rows={2}
                                                name={`rows[${index}].goods_description`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.goods_description}
                                            ></textarea>
                                        </td>
                                        <td>
                                            {formik.values.rows.length > 1 && (
                                                <button
                                                    type="button"
                                                    title='Remove rates'
                                                    className="btn btn-sm btn-danger me-1"
                                                    onClick={() => {
                                                        const newRows = formik.values.rows.filter(
                                                            (_, i) => i !== index
                                                        );
                                                        formik.setFieldValue("rows", newRows);
                                                    }}
                                                >
                                                    -
                                                </button>
                                            )}
                                            {index === formik.values.rows.length - 1 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary ms-1"
                                                    onClick={() => {
                                                        const newRows = [...formik.values.rows];
                                                        newRows.push({
                                                            no_of_pkg: "",
                                                            gross_wt: "",
                                                            kg_lb: "",
                                                            rate_class: "",
                                                            comm_item_No: "",
                                                            chargeable_wt: "",
                                                            rate_charge: "",
                                                            total_freight: "",
                                                        });
                                                        formik.setFieldValue("rows", newRows);
                                                    }}
                                                >
                                                    +
                                                </button>
                                            )}

                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>


                    <h4 className='mt-2 subheading-strip'>Other Particulars</h4>
                    <div className="col-md-3 mt-2">
                        <InputTextJSX labelText={"Address"} nameValue={"other_particular_address"} value={formik.values.other_particular_address} onChange={formik.handleChange} maxLength={250} />
                    </div>
                    
                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Country
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={countryOptions}
                                    styles={customStyles}
                                    name="other_particular_country"
                                    onChange={option => {
                                        formik.setFieldValue('other_particular_country', option.value);
                                    }}
                                    value={countryOptions.find(option => option.value == formik.values.other_particular_country || null)}
                                    isLoading={loadingFFSICountry}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                State
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={stateOptions}
                                    styles={customStyles}
                                    name="other_particular_state"
                                    onChange={option => {
                                        formik.setFieldValue('other_particular_state', option.value);
                                    }}
                                    value={stateOptions.find(option => option.value == formik.values.other_particular_state || null)}
                                    isLoading={loadingFFSIState}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                City
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={cityOptions}
                                    styles={customStyles}
                                    name="other_particular_city"
                                    onChange={option => {
                                        formik.setFieldValue('other_particular_city', option.value);
                                    }}
                                    value={cityOptions.find(option => option.value == formik.values.other_particular_city || null)}
                                    isLoading={loadingFFSICity}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <InputTextJSX labelText={"Zip Code"} nameValue={"other_particular_zipcode"} value={formik.values.other_particular_zipcode} onChange={formik.handleChange} maxlength={6}/> */}
                    <div className={`col-md-3 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Zip Code
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="text"
                                    maxLength={6}
                                    className="form-control form-control-sm"
                                    id={"other_particular_zipcode"}
                                    name={"other_particular_zipcode"}
                                    value={formik.values.other_particular_zipcode}
                                    onChange={formik.handleChange}
                                    onInput={(event) => {
                                        let value = event.target.value;
                                        value = value.replace(/[^0-9]/g, '');
                                        event.target.value = value;
                                    }}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row d-flex justify-content-end mt-2">
                    <div className="col-md-6 d-flex justify-content-end">
                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Add"}
                        </button>
                    </div>
                </div>
            </form>

        </>
    )
}

export default ConsoleShipmentSIHBLAdd